import type { AppRouteMeta } from '@/routing/route-meta';

// TanStack Router supports arbitrary per-route `staticData` via module augmentation.
// We use it to attach app-specific navigation + access metadata to routes.

declare module '@tanstack/react-router' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface StaticDataRouteOption {
    app?: AppRouteMeta;
  }
}

function hasAppStaticData(value: unknown): value is { app?: AppRouteMeta } {
  return typeof value === 'object' && value !== null && 'app' in value;
}

export function getAppRouteMeta(route: {
  options?: { staticData?: unknown };
}): AppRouteMeta | undefined {
  const staticData = route.options?.staticData;
  return hasAppStaticData(staticData) ? staticData.app : undefined;
}
